import type { ReactNode } from 'react';
import { initials } from '@lib/format';

export type AvatarSize = 'sm' | 'md' | 'nav' | 'lg' | 'xl';
/** ink: a person; muted: not a person (system, CLI) or an inactive / deleted account; alert: a stranger at the sign-in */
export type AvatarTone = 'ink' | 'muted' | 'alert';

/**
 * A round badge with a person's initials (or an icon for something that is not a person). Decorative: the name it
 * stands for is always written next to it. Sizes: sm 28, md 32, nav 36, lg 44, xl 64 px.
 */
export function Avatar({ name, icon, size = 'md', tone = 'ink', className = '' }: { name?: string; icon?: ReactNode; size?: AvatarSize; tone?: AvatarTone; className?: string }) {
  return (
    <span className={`avatar avatar-${size} ${tone === 'ink' ? '' : `avatar-${tone}`} ${className}`} aria-hidden="true">
      {icon ?? initials(name ?? '')}
    </span>
  );
}
